export const BASE_URL = "https://apis.quirosreyes.com/games"